import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import fetchCountryOptions from "../../../scripts/countryOptions";
import { IcountryOptions } from "../../../typings/models/CountryOption";
import { countryMobileCodes } from "../../../scripts/countryMobileCodes";
import { savePetsRegistration } from "../../../api/apimethods";
import { IPetsRegRequests } from "../../../typings/interfaces/Requests/PetsRegRequests";
import { IPetColorModel } from "../../../typings/models/PetColorModel";
import fetchColoursOption from "../../../scripts/coloursOption";
import { useNavigate, useLocation } from "react-router-dom";
import fetchAnimalTypes from "../../../scripts/animalTypes";
import { IAnimalTypesModel } from "../../../typings/models/AnimalTypesModel";
import fetchPetBreeds from "../../../scripts/petBreedOptions";
import { IPetBreedModel } from "../../../typings/models/PetBreedModel";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useConfig } from "../../../context/ConfigProvider";
import { useAuthService, useContextService } from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../../components/molecules/Loader";
interface TabPetsProfileProps {
  onSuccessfulSubmit: () => void;
}

interface LocationState {
  petsRegistrationId: string;
  buttonId: string;
  tabId: string;
  bannerId: number;
}
const TabPetsProfile: React.FC<TabPetsProfileProps> = ({
  onSuccessfulSubmit,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  let navigate = useNavigate();
  const location = useLocation();
  const petsRegistrationId = (location.state as LocationState)
    ?.petsRegistrationId;
  const [serviceType, setServiceType] = useState<number>(0);
  const [serviceTypeSelected, setServiceTypeSelected] = useState(false);
  const [vetCentreCode, setvetCentreCode] = useState("");
  const [animalType, setAnimalType] = useState("");
  const [animalTypeLabel, setAnimalTypeLabel] = useState("");
  const [breed, setBreed] = useState("");
  const [origin, setOrigin] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [originCountries, setOriginCountries] = useState<IcountryOptions[]>([]);
  const [colourOptions, setColourOptions] = useState<IPetColorModel[]>([]);
  const [animalTypes, setAnimalTypes] = useState<IAnimalTypesModel[]>([]);
  const [breedOptionsByAnimalType, setBreedOptionsByAnimalType] = useState<
    Record<string, IPetBreedModel[]>
  >({});
  const [microchipNo, setMicrochipNo] = useState("");
  const [microchipDate, setMicrochipDate] = useState("");
  const [nameofPet, setNameofPet] = useState("");
  const [dateofBirthPet, setDateofBirthPet] = useState("");
  const [sex, setSex] = useState("");
  const [remarks, setRemarks] = useState("");
  const [petStatus, setPetStatus] = useState<any>(null);
  const [colour, setColour] = useState("");
  const [sterilised, setSterilised] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [blockNumber, setBlockNumber] = useState("");
  const [streetName, setStreetName] = useState("");
  const [unitNumber, setUnitNumber] = useState("");
  const [floorNumber, setFloorNumber] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [ownerIdType, setOwnerIdType] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [opostalCode, setoPostalCode] = useState("");
  const [oblockNumber, setoBlockNumber] = useState("");
  const [ostreetName, setoStreetName] = useState("");
  const [ounitNumber, setoUnitNumber] = useState("");
  const [ofloorNumber, setoFloorNumber] = useState("");
  const [obuildingName, setoBuildingName] = useState("");
  const [mobileNo, setmobileNo] = useState("");
  const [mobilecode, setMobileCode] = useState("+65");
  const [amobileNo, setamobileNo] = useState("");
  const [amobilecode, setaMobileCode] = useState("+65");
  const [email, setEmail] = useState("");
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [ofloorNoShowError, setofloorNoShowError] = useState(true);
  const [ounitNoShowError, setounitNoShowError] = useState(true);
  const [oblockNoShowError, setoblockNoShowError] = useState(true);
  const [opostalCodeShowError, setopostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [avalidMobileNo, setaValidMobileNo] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [isMicrochipValid, setIsMicrochipValid] = useState(true);
  const [isMicrochipValidOversease, setIsMicrochipValidOversease] =
    useState(true);
  const [microchipAlreadyExists, setMicrochipAlreadyExists] = useState(false);
  const [loginType, setLoginType] = useState("SingPass");
  const inputCountryRef = useRef(true);
  const inputColoursRef = useRef(true);
  const inputAnimalTypeRef = useRef(true);
  const inputPetBreedRef = useRef(true);
  const inputUserRef = useRef(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [petAddressErrorMessage, setPetAddressErrorMessage] = useState("");
  const [ownerAddressErrorMessage, setOwnerAddressErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [addressReadOnly, setAddressReadOnly] = useState(true);
  const [ownerReadOnly, setOwnerReadOnly] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate()); // Set it to today
  const maxdate = currentDate.toISOString().split("T")[0];
  const minDate = "1990-01-01";
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [isMinValidDate, setisMinValidDate] = useState(true);
  const [isValidDateofBirth, setisValidDateofBirth] = useState(true);
  const [isMinValidDateofBirth, setisMinValidDateofBirth] = useState(true);
  const [petsRegistration, setpetsRegistrationId] =
    useState(petsRegistrationId);
  const transferType = "PetsRegistration";
  const elementRef = useRef<HTMLInputElement>(null);
  const errorRef = useRef<HTMLButtonElement>(null);
  const handleOriginChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    if (microchipNo !== "") {
      if (value === "1") {
        const isValid = /^\d{15}$/.test(microchipNo);
        setIsMicrochipValid(isValid);
        setIsMicrochipValidOversease(true);
      } else if (value === "2") {
        const isValid = /^[a-zA-Z0-9]{3,100}$/.test(microchipNo);
        setIsMicrochipValid(true);
        setIsMicrochipValidOversease(isValid);
      }
    }

    if (value === "1") {
      const singaporeFilteredCountries = countries.filter(
        (country) => country.label === "Singapore"
      );
      setOriginCountries(singaporeFilteredCountries);
      setCountryOfOrigin(singaporeFilteredCountries[0]?.value);
    } else if (value === "2") {
      setOriginCountries(countries);
    }
    setOrigin(value);
  };

  const handleMicrochipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setIsMicrochipValid(false);
    setMicrochipAlreadyExists(false);

    if (origin === "1") {
      const isValid = /^\d{15}$/.test(value);
      setIsMicrochipValid(isValid);
      setIsMicrochipValidOversease(true);
    } else if (origin === "2") {
      const isValid = /^[a-zA-Z0-9]{3,100}$/.test(value);
      setIsMicrochipValid(true);
      setIsMicrochipValidOversease(isValid);

      if (value === "") {
        setIsMicrochipValidOversease(false);
      }
    }
    setMicrochipNo(value);
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (maxdateObj >= selectedDateObj) {
      setMicrochipDate(selectedDate);
      setisValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(false);
      setMicrochipDate("");
    }
    if (mindateObj <= selectedDateObj) {
      setMicrochipDate(selectedDate);
      setisMinValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(true);
      setisMinValidDate(false);
      setMicrochipDate("");
    }
  };

  const handlePetbirthDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (maxdateObj >= selectedDateObj) {
      setDateofBirthPet(selectedDate);
      setisValidDateofBirth(true);
    } else {
      event.preventDefault();
      setisValidDateofBirth(false);
      setDateofBirthPet("");
    }
    if (mindateObj <= selectedDateObj) {
      setDateofBirthPet(selectedDate);
      setisMinValidDateofBirth(true);
    } else {
      event.preventDefault();
      setisValidDateofBirth(true);
      setisMinValidDateofBirth(false);
      setDateofBirthPet("");
    }
  };

  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setBlockNumber(value);
      setblockNoShowError(true);
    } else {
      if (value === "") {
        setBlockNumber(value);
        setblockNoShowError(true);
      } else {
        setblockNoShowError(false);
      }
    }
  };

  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setPostalCode(value);
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setPostalCode(value);
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };

  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

      if (new RegExp(pattern).test(value)) {
        setUnitNumber(value);
        setunitNoShowError(true);
      } else {
        if (value === "") {
          setUnitNumber(value);
          setunitNoShowError(true);
        } else {
          setunitNoShowError(false);
        }
      }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setFloorNumber(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setFloorNumber(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };

  const oblockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setoBlockNumber(value);
      setoblockNoShowError(true);
    } else {
      if (value === "") {
        setoBlockNumber(value);
        setoblockNoShowError(true);
      } else {
        setoblockNoShowError(false);
      }
    }
  };

  const opostalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setoPostalCode(value);
      setopostalCodeShowError(true);
    } else {
      if (value === "") {
        setoPostalCode(value);
        setopostalCodeShowError(true);
      } else {
        setopostalCodeShowError(false);
      }
    }
  };

  const handleOwnerAddressClick = async () => {
    var address = await GetOnMapAddress(opostalCode);
    if (address) {
      setoBlockNumber(address.BLK_NO);
      setoBuildingName(address.BUILDING);
      setoStreetName(address.ROAD_NAME);
      setOwnerAddressErrorMessage("");
    } else {
      setoBlockNumber("");
      setoBuildingName("");
      setoStreetName("");
      setOwnerAddressErrorMessage("Address not found for the postal code");
    }
  };

  const handlePetAddressClick = async () => {
    var address = await GetOnMapAddress(postalCode);
    if (address) {
      setBlockNumber(address.BLK_NO);
      setBuildingName(address.BUILDING);
      setStreetName(address.ROAD_NAME);
      setPetAddressErrorMessage("");
    } else {
      setBlockNumber("");
      setBuildingName("");
      setStreetName("");
      setPetAddressErrorMessage("Address not found for the postal code");
    }
  };

  const GetOnMapAddress = async (postalCode: string) => {
    const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${postalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
      console.error("Error:", response);
      return;
    }
    const data = await response.json();

    if (data.found > 0) return data.results[0];
    else return null;
  };

  const ounitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

      if (new RegExp(pattern).test(value)) {
        setoUnitNumber(value);
        setounitNoShowError(true);
      } else {
        if (value === "") {
          setoUnitNumber(value);
          setounitNoShowError(true);
        } else {
          setounitNoShowError(false);
        }
      }
  };

  const ofloorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setoFloorNumber(value);
      setofloorNoShowError(true);
    } else {
      if (value === "") {
        setoFloorNumber(value);
        setofloorNoShowError(true);
      } else {
        setofloorNoShowError(false);
      }
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setmobileNo(value);
      if (value.length >= 8) {
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setmobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }

    if (mobilecode === "+65") {
      const isValid = /^[0-9]{8}$/.test(value);
      setValidMobileNo(isValid);
    } else {
      setValidMobileNo(true);
    }
  };

  const amobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setamobileNo(value);
      if (value.length >= 8) {
        setaValidMobileNo(true);
      } else {
        setaValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setamobileNo(value);
        setaValidMobileNo(true);
      } else {
        setaValidMobileNo(false);
      }
    }
    if (amobilecode === "+65") {
      const isValid = /^\d{8}$/.test(value);
      setaValidMobileNo(isValid);
    } else {
      setaValidMobileNo(true);
    }
  };

  const toBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const base64 = await toBase64(file);
      setSelectedFile(base64);
      setSelectedFileName(file.name);
    }
  };

  const resetForm = () => {
    setServiceType(0);
    setServiceTypeSelected(false);
    setAnimalType("");
    setisCommunityCat("");
    setAnimalTypeLabel("");
    setCountryOfOrigin("");
    setMicrochipNo("");
    setMicrochipDate("");
    setNameofPet("");
    setOwnerId("");
    setOwnerIdType("");
    setOwnerName("");
    setDateofBirthPet("");
    setSex("");
    setRemarks("");

    setColour("");
    setOrigin("");
    setSterilised("");
    setPostalCode("");
    setBlockNumber("");
    setStreetName("");
    setUnitNumber("");
    setFloorNumber("");
    setBuildingName("");
    setOwnerId("");
    setOwnerIdType("");
    setOwnerName("");
    setoPostalCode("");
    setoBlockNumber("");
    setoStreetName("");
    setoUnitNumber("");
    setoFloorNumber("");
    setoBuildingName("");
    setmobileNo("");
    setMobileCode("+65");
    setamobileNo("");
    setaMobileCode("+65");
    setEmail("");
    setSelectedFile(null);
    setSelectedFileName("");
    setCheckboxChecked(false);
    recaptchaRef.current?.reset();

    const form = document.querySelector(".needs-validation");
    if (form instanceof HTMLFormElement) {
      form.classList.remove("was-validated");
    }
    setSubmitted(false);
  };
  const [selectType, setSelectType] = useState<number>(0);
  const [isCommunityCat, setisCommunityCat] = useState<any>(null);

  const handleSelectTypeChange = (newSelectType: number) => {
    setSelectType(newSelectType);

    if (newSelectType === 1) {
      setAddressReadOnly(true);
      setPostalCode(opostalCode);
      setBlockNumber(oblockNumber);
      setStreetName(ostreetName);
      setUnitNumber(ounitNumber);
      setFloorNumber(ofloorNumber);
      setBuildingName(obuildingName);
    } else if (newSelectType === 2) {
      setAddressReadOnly(false);
      setPostalCode("");
      setBlockNumber("");
      setStreetName("");
      setUnitNumber("");
      setFloorNumber("");
      setBuildingName("");
    }
  };

  // const handleCommunityCatChange = (value: number) => {
  //   setisCommunityCat(value);
  // };

  // useEffect(() => {
  //   if (inputUserRef.current) {
  //     inputUserRef.current = false;
  //     if (user !== undefined) {
  //       if (user.role !== undefined) {
  //         setLoginType(user.role);
  //       }

  //       if (user.role === "SingPass") {
  //         setOwnerReadOnly(true);
  //         setOwnerIdType("2");

  //         if (user.name !== undefined) {
  //           setOwnerName(user.name);
  //         }

  //         if (user.idNo !== undefined) {
  //           setOwnerId(user.idNo);
  //         }

  //         setServiceType(1);
  //       }

  //       if (user.role === "CorpPass") {
  //         if (user.idType !== undefined) {
  //           setOwnerIdType("4");
  //         }

  //         if (user.uen !== undefined) {
  //           setOwnerId(user.uen);
  //         }
  //       } else if (user.role === "ForeignerLogin") {
  //         setOwnerReadOnly(false);
  //         setOwnerIdType("2");
  //         setServiceType(1);
  //         if (user.name !== undefined) {
  //           setOwnerName(user.name);
  //         }
  //         if (user.idNo !== undefined) {
  //           setOwnerId(user.idNo);
  //         }
  //       }

  //       if (user.contactNo !== undefined) {
  //         setMobileCode(user.contactNo.substring(0, 3));
  //         setmobileNo(user.contactNo.substring(3));
  //       } else {
  //         setmobileNo("");
  //         setMobileCode("+65");
  //       }

  //       if (user.email !== undefined) {
  //         setEmail(user.email);
  //
  //       }

  //       if (user.registeredAddresses !== undefined) {
  //         setoPostalCode(user.registeredAddresses.postalCode);
  //         setoBlockNumber(user.registeredAddresses.blockHouseNo);
  //         setoStreetName(user.registeredAddresses.streetName);
  //         setoFloorNumber(user.registeredAddresses.floorLevel);
  //         setoUnitNumber(user.registeredAddresses.unit);
  //         setoBuildingName(user.registeredAddresses.buildingName);
  //       }
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (inputUserRef.current) {
      inputUserRef.current = false;
      if (user !== undefined) {
        if (user.role !== undefined) {
          setLoginType(user.role);
        }

        if (user.role === "SingPass") {
          setOwnerReadOnly(true);
          setOwnerIdType("2");

          if (user.name !== undefined) {
            setOwnerName(user.name);
          }

          if (user.idNo !== undefined) {
            setOwnerId(user.idNo);
          }

          setServiceType(1);
        }

        if (user.role === "CorpPass") {
          if (user.idType !== undefined) {
            setOwnerIdType("4");
          }

          if (user.uen !== undefined) {
            setOwnerId(user.uen);
          }
        } else if (user.role === "ForeignerLogin") {
          setOwnerReadOnly(false);
          setOwnerIdType("2");
          setServiceType(1);
          if (user.name !== undefined) {
            setOwnerName(user.name);
          }
          if (user.idNo !== undefined) {
            setOwnerId(user.idNo);
          }
        }

        if (user.contactNo) {
          setMobileCode(user.contactNo.substring(0, 3));
          setmobileNo(user.contactNo.substring(3));
        } else {
          setmobileNo("");
          setMobileCode("+65");
        }

        if (user.email !== undefined) {
          setEmail(user.email);
        }

        if (user.registeredAddresses !== undefined) {
          setoPostalCode(user?.registeredAddresses?.[0]?.postalCode);
          setoBlockNumber(user?.registeredAddresses?.[0]?.blockHouseNo);
          setoStreetName(user?.registeredAddresses?.[0]?.streetName);
          setoFloorNumber(user?.registeredAddresses?.[0]?.floorLevel);
          setoUnitNumber(user?.registeredAddresses?.[0]?.unit);
          setoBuildingName(user?.registeredAddresses?.[0]?.buildingName);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setOriginCountries(countries);
        setCountries(countries);
        setIsLoading(false);
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (inputColoursRef.current) {
      inputColoursRef.current = false;
      const fetchColourData = async () => {
        const petsColours = await fetchColoursOption();
        setColourOptions(petsColours);
      };

      fetchColourData();
    }
  }, []);

  useEffect(() => {
    if (inputAnimalTypeRef.current) {
      inputAnimalTypeRef.current = false;
      const fetchAnimalType = async () => {
        const animalTypes = await fetchAnimalTypes();
        setAnimalTypes(animalTypes);
      };

      fetchAnimalType();
    }
  }, []);

  useEffect(() => {
    if (inputPetBreedRef.current) {
      inputPetBreedRef.current = false;
      const fetchPetBreed = async () => {
        const petBreeds = await fetchPetBreeds();
        const breedOptions = petBreeds.reduce((options, petBreed) => {
          const animalTypeId = petBreed.animalType;
          options[animalTypeId] = options[animalTypeId] || [];
          options[animalTypeId].push(petBreed);
          return options;
        }, {} as Record<string, IPetBreedModel[]>);
        setBreedOptionsByAnimalType(breedOptions);
      };

      fetchPetBreed();
    }
  }, []);

  const handleCountryofOriginChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCountryOfOrigin(event.target.value);
  };

  const isServiceTypeSelected = () => {
    return serviceType !== null && serviceType !== 0;
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const handleAnimalTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedAnimalType = event.target.value;
    const selectedAnimalTypelabel =
      animalTypes.find((type) => type.id === selectedAnimalType)?.name ?? "";
    setAnimalType(selectedAnimalType);
    setAnimalTypeLabel(selectedAnimalTypelabel);
    setBreed("");
  };

  const handleOwnerIdTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedOwnerIdType = event.target.value;
    setOwnerIdType(selectedOwnerIdType);
  };

  if (isLoading) {
    return <Loader />;
  }

  const handleSuccessfulSubmit = () => {
    onSuccessfulSubmit();
  };

  function handleCapture(event: React.FormEvent<HTMLFormElement>) {
    if (errorRef.current) {
      errorRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  const handleSubmit = async (
    event:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();

    setSubmitted(true);

    setDisableSubmit(true);

    const reCaptchaResponse = recaptchaRef.current?.getValue();

    let aServiceType = isServiceTypeSelected();
    setServiceTypeSelected(aServiceType);

    if (!reCaptchaResponse) {
      setIsCaptchaValid(false);
      setDisableSubmit(false);
      return;
    }

    if (dateofBirthPet > microchipDate) {
      setisValidDateofBirth(false);
      setDisableSubmit(false);
      return;
    }

    if (isAllValidation()) {
      try {
        const PetsRegRequestData: IPetsRegRequests = {
          PetsRegistrationId: petsRegistration,
          ServiceType: serviceType,
          CentreCode: vetCentreCode,
          AnimalType: animalType,
          Breed: breed,
          LoginType:
            user.role === "SingPass"
              ? "1"
              : user.role === "CorpPass"
              ? "2"
              : "3",

          mode: 1,
          PetsInformations: {
            petInformationType: selectType,
            Origin: origin,
            CountryOfOrigin: countryOfOrigin,
            MicrochipNo: microchipNo,
            MicrochipDate: microchipDate,
            PetsName: nameofPet,
            PetsDateOfBirth: dateofBirthPet,
            PetsSex: sex,
            remarks: remarks,
            PetStatus: petStatus,
            PetsColour: colour,
            Sterilised: sterilised,
            isCommunityCat: isCommunityCat,
            BlockHouseNumber: blockNumber,
            StreetName: streetName,
            FloorNumber: floorNumber,
            UnitNumber: unitNumber,
            BuildingName: buildingName,
            PostalCode: postalCode,
          },
          OwnerInformations: {
            OwnerID: ownerIdType,
            OwnerIDNumber: ownerId,
            OwnerName: ownerName,
            BlockHouseNumber: oblockNumber,
            StreetName: ostreetName,
            FloorNumber: ofloorNumber,
            UnitNumber: ounitNumber,
            BuildingName: obuildingName,
            PostalCode: opostalCode,
            OwnerContactNo: mobilecode + mobileNo,
            OwnerAlternateContactNo: amobilecode + amobileNo,
            OwnerEmail: email,
          },
          attachment: selectedFile,
          attachmentName: selectedFileName,
        };

        if (
          PetsRegRequestData.OwnerInformations.OwnerID === "2" &&
          PetsRegRequestData.OwnerInformations.OwnerIDNumber === "VX123456"
        ) {
          const errorMessage =
            "<You are/This Owner ID is> not allowed to register for a pet microchip.";

          setErrorMessage(errorMessage);
          setDisableSubmit(false);
          return;
        }

        setSubmiting(true);

        const response = await savePetsRegistration(PetsRegRequestData);

        if (response.data.data) {
          setSubmiting(false);
          const successMessage =
            "You have registered a " +
            animalTypeLabel +
            " with Microchip No. " +
            microchipNo;
          alert(successMessage);
          resetForm();
          onSuccessfulSubmit();
        } else {
          setSubmiting(false);
          const errorMessage = response.data.message;

          setErrorMessage(errorMessage);

          if (errorRef.current) {
            errorRef.current.scrollIntoView({ behavior: "smooth" });
          }

          if (response.data.code === 409) {
            setMicrochipAlreadyExists(true);
            if (elementRef.current) {
              elementRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }
        }
      } catch (error) {
        setSubmiting(false);
        console.error("Error during form submission:", error);
      }
    }

    setDisableSubmit(false);
  };

  async function handleClear() {
    setServiceType(0);
    setServiceTypeSelected(false);
    setAnimalType("");
    setisCommunityCat("");
    setAnimalTypeLabel("");
    setCountryOfOrigin("");
    setMicrochipNo("");
    setMicrochipDate("");
    setNameofPet("");
    setDateofBirthPet("");
    setSex("");
    setRemarks("");
    setColour("");
    setOrigin("");
    setSterilised("");
    setPostalCode("");
    setBlockNumber("");
    setStreetName("");
    setUnitNumber("");
    setFloorNumber("");
    setBuildingName("");
    setSelectedFile(null);
    setSelectedFileName("");
    setCheckboxChecked(false);
    recaptchaRef.current?.reset();

    const form = document.querySelector(".needs-validation");
    if (form instanceof HTMLFormElement) {
      form.classList.remove("was-validated");
    }
    setSubmitted(false);
  }

  (function () {
    

    var forms = document.querySelectorAll(".needs-validation");
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();

  const isAllValidation = () => {
    return (
      isValidDate &&
      checkboxChecked &&
      validEmail &&
      animalType &&
      breed &&
      (animalType !== "e0df8145-1d5d-ed11-9561-0022485935af" ||
        isCommunityCat !== null) &&
      origin &&
      sex &&
      sterilised &&
      selectType &&
      dateofBirthPet &&
      nameofPet &&
      microchipDate &&
      microchipNo &&
      opostalCode &&
      oblockNumber &&
      ofloorNumber &&
      ostreetName &&
      ounitNumber &&
      mobileNo &&
      colour
    );
  };

  return (
    <>
      {(loginType === "SingPass" || loginType === "ForeignerLogin") && (
        <div>
          <h2 className="pb-2">Registration</h2>
          <div className="inst-cnt mt-4 mb-2">
            <span className="est-time">
              This pet microchip registration does not equate to licensing. To
              license your pet, please go to the Pet Animal Licensing System
              (PALS) to apply for a licence.
              <br />
              Estimated time to complete: 15 mins
            </span>
          </div>
          <form
            className="row g-3 needs-validation"
            onSubmit={handleSubmit}
            noValidate
          >
            <div
              className="passport-details hidden csp-display-block"
              id="passport"
            >
              <h2 className="pt-2 pb-0">Owner Information</h2>
              <div className="inst-cnt mt-2">
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    1. Owner ID Type <span className="star">*</span>{" "}
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="ownerIdType"
                    value={ownerIdType}
                    onChange={handleOwnerIdTypeChange}
                    required
                    disabled
                  >
                    <option value=""></option>
                    <option value="2">NRIC</option>
                    <option value="1">FIN</option>
                    <option value="4">UEN</option>
                  </select>
                  {submitted && !ownerIdType && !ownerReadOnly && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please select Owner ID Type.
                    </div>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    2. Owner ID <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !ownerId && !ownerReadOnly
                        ? "is-invalid"
                        : ""
                    }`}
                    id="ownerId"
                    placeholder=""
                    maxLength={25}
                    value={ownerId}
                    onChange={(event) => setOwnerId(event.target.value)}
                    required
                    disabled
                  />
                  {submitted && !ownerId && !ownerReadOnly && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide an Owner ID.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    3. Owner Name <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !ownerName && !ownerReadOnly
                        ? "is-invalid"
                        : ""
                    }`}
                    id="ownerName"
                    placeholder=""
                    maxLength={355}
                    value={ownerName}
                    onChange={(event) => setOwnerName(event.target.value)}
                    required
                    disabled
                  />
                  {submitted && !ownerName && !ownerReadOnly && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide an Owner Name.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    4. Owner Address
                  </label>
                  <div className="row">
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Postal Code <span className="star">*</span>
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className={`form-control ${
                            submitted && !opostalCode && !ownerReadOnly
                              ? "is-invalid"
                              : ""
                          }`}
                          id="opostalCode"
                          placeholder=""
                          maxLength={8}
                          pattern="[0-9]+"
                          value={opostalCode}
                          onChange={opostalCodeHandler}
                          required
                          disabled={ownerReadOnly}
                        />
                        {submitted && !opostalCode && !ownerReadOnly && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please provide a Postal Code.
                          </div>
                        )}
                        {!opostalCodeShowError && !ownerReadOnly && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter numbers only. eg. "123456"
                          </div>
                        )}
                        {ownerAddressErrorMessage && !ownerReadOnly && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            {ownerAddressErrorMessage}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn btn-success d-block mt-4"
                        onClick={handleOwnerAddressClick}
                        disabled={ownerReadOnly}
                      >
                        Get Address
                      </button>
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Block/House Number <span className="star">*</span>
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className={`form-control ${
                            submitted && !oblockNumber && !ownerReadOnly
                              ? "is-invalid"
                              : ""
                          }`}
                          id="oblockNumber"
                          placeholder=""
                          maxLength={4}
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={oblockNumber}
                          onChange={oblockNoHandler}
                          required
                          disabled={ownerReadOnly}
                        />
                        {submitted && !oblockNumber && !ownerReadOnly && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please provide a Block/House Number.
                          </div>
                        )}
                        {!oblockNoShowError && !ownerReadOnly && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter characters only. eg. "64FB"
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-1 small-label"
                    >
                      Floor Number <span className="star">*</span>
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        className={`form-control ${
                          submitted && !ofloorNumber && !ownerReadOnly
                            ? "is-invalid"
                            : ""
                        }`}
                        id="ofloorNumber"
                        placeholder=""
                        pattern="^[a-zA-Z0-9\s]+$"
                        value={ofloorNumber}
                        onChange={ofloorNoHandler}
                        maxLength={3}
                        disabled={ownerReadOnly}
                      />
                      {submitted && !ofloorNumber && !ownerReadOnly && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please provide a Floor Number.
                        </div>
                      )}
                      {!ofloorNoShowError && !ownerReadOnly && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please enter numbers only, e.g. "123".
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-1 small-label"
                    >
                      Street Name <span className="star">*</span>
                    </label>
                    <div className="mb-3 position-relative">
                      <input
                        type="text"
                        className={`form-control ${
                          submitted && !ostreetName && !ownerReadOnly
                            ? "is-invalid"
                            : ""
                        }`}
                        id="ostreetName"
                        placeholder=""
                        maxLength={64}
                        value={ostreetName}
                        onChange={(event) => setoStreetName(event.target.value)}
                        required
                        disabled={ownerReadOnly}
                      />
                      {submitted && !ostreetName && !ownerReadOnly && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please provide a Street Name.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-1 small-label"
                    >
                      Unit Number <span className="star">*</span>
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        className={`form-control ${
                          submitted && !ounitNumber && !ownerReadOnly
                            ? "is-invalid"
                            : ""
                        }`}
                        id="ounitNumber"
                        placeholder=""
                        pattern="^[a-zA-Z0-9\s]+$"
                        value={ounitNumber}
                        onChange={ounitNoHandler}
                        maxLength={4}
                        disabled={ownerReadOnly}
                      />
                      {submitted && !ounitNumber && !ownerReadOnly && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please provide a Unit Number.
                        </div>
                      )}
                      {!ounitNoShowError && !ownerReadOnly && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please enter numbers only, e.g. "1234".
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-1 small-label"
                    >
                      Building Name
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        className={`form-control ${
                          submitted && !obuildingName && !ownerReadOnly ? "is-invalid" : ""
                        }`}
                        id="obuildingName"
                        placeholder=""
                        maxLength={64}
                        value={obuildingName}
                        onChange={(event) =>
                          setoBuildingName(event.target.value)
                        }
                        disabled={ownerReadOnly}
                      />
                      {submitted && !obuildingName && !ownerReadOnly && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please provide a Building Name.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      5. Owner Contact No <span className="star">*</span>
                    </label>

                    <div className="row">
                      <div className="col-md-2">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="mobilecode"
                          value={mobilecode}
                          onChange={(e) => setMobileCode(e.target.value)}
                          required
                        >
                          {countryMobileCodes.map((code: any) => (
                            <option key={code} value={code}>
                              {code}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-10">
                        <input
                          type="text"
                          aria-describedby="emailHelp"
                          className={`form-control ${
                            submitted && !validMobileNo ? "is-invalid" : ""
                          }`}
                          id="mobileNo"
                          placeholder=""
                          pattern="[0-9]+"
                          value={mobileNo}
                          onChange={mobileNoHandler}
                          maxLength={mobilecode === "+65" ? 8 : 66}
                          required
                        />
                        {submitted && (
                          <>
                            {(!mobileNo || !validMobileNo) && (
                              <div className="error-message">
                                <FontAwesomeIcon
                                  className="me-1"
                                  icon={faCircleExclamation}
                                />
                                Please provide a valid Contact No.
                              </div>
                            )}

                            {mobileNo &&
                              mobilecode === "+65" &&
                              !validMobileNo && (
                                <div className="error-message">
                                  <FontAwesomeIcon
                                    className="me-1"
                                    icon={faCircleExclamation}
                                  />
                                  Invalid mobile no. e.g. +6591234567
                                </div>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      6. Owner alternate Contact No.
                    </label>

                    <div className="row">
                      <div className="col-md-2">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="amobilecode"
                          value={amobilecode}
                          onChange={(e) => setaMobileCode(e.target.value)}
                        >
                          {countryMobileCodes.map((code: any) => (
                            <option key={code} value={code}>
                              {code}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-10">
                        <input
                          type="text"
                          aria-describedby="emailHelp"
                          className={`form-control ${
                            submitted && !avalidMobileNo ? "is-invalid" : ""
                          }`}
                          id="amobileNo"
                          placeholder=""
                          pattern="[0-9]+"
                          value={amobileNo}
                          onChange={amobileNoHandler}
                          maxLength={amobilecode === "+65" ? 8 : 66}
                        />
                        {submitted && !avalidMobileNo && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Invalid mobile no. e.g. +6591234567
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      7. Owner Email<span className="star">*</span>
                    </label>
                    <input
                      type="email"
                      className={`form-control ${
                        submitted && !validEmail ? "is-invalid" : ""
                      }`}
                      id="email"
                      placeholder=""
                      maxLength={255}
                      value={email}
                      onChange={handleEmailChange}
                      required
                    />
                    {submitted && !email && (
                      <div className="error-message">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faCircleExclamation}
                        />
                        Please provide a valid email address.
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <h2 className="pb-0">Pet Information</h2>
              <div className="inst-cnt mt-2">
                {/* components should be there */}

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`form-label mb-2 ${
                      !isServiceTypeSelected() ? "required" : ""
                    }`}
                  >
                    8. This request for service is for{" "}
                    <span className="star">*</span>{" "}
                  </label>
                  <div
                    className={`form-check ${
                      !isServiceTypeSelected() ? "is-invalid" : ""
                    }`}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="serviceType"
                      value="Myself"
                      id="flexRadioDefault66"
                      checked={serviceType === 1}
                      onChange={() => setServiceType(1)}
                      required
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault66"
                    >
                      Myself
                    </label>
                  </div>
                  {/* <div
                className={`form-check ${
                  !isServiceTypeSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="serviceType"
                  value="Organisation"
                  id="flexRadioDefault77"
                  checked={serviceType === 2}
                  onChange={() => setServiceType(2)}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault77"
                >
                  Organisation
                </label>
              </div>*/}
                  <div
                    className={`form-check ${
                      !isServiceTypeSelected() ? "is-invalid" : ""
                    }`}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="serviceType"
                      value="Organisation"
                      id="flexRadioDefault88"
                      checked={serviceType === 3}
                      onChange={() => setServiceType(3)}
                      readOnly
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault88"
                    >
                      On Behalf of Owner
                    </label>
                  </div>
                  {submitted && !isServiceTypeSelected() && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please select a Service Type.
                    </div>
                  )}
                </div>
                {/* <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                2. Vet Centre Code
              </label>
              <input
                type="text"
                className="form-control"
                id="VetCentreCode"
                placeholder=""
                maxLength={15}
                value={vetCentreCode}
                onChange={(event) => setvetCentreCode(event.target.value)}
              />
            </div> */}
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    9. Animal Type <span className="star">*</span>{" "}
                  </label>
                  <select
                    className={`form-select ${
                      submitted && !animalType ? "is-invalid" : ""
                    }`}
                    aria-label="Default select example"
                    id="animalType"
                    value={animalType}
                    onChange={handleAnimalTypeChange}
                    required
                  >
                    <option value=""></option>
                    {animalTypes.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  {submitted && !animalType && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide an Animal Type.
                    </div>
                  )}
                </div>
                {animalType === "e0df8145-1d5d-ed11-9561-0022485935af" && (
                  <>
                    <div>
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Community Cat <span className="star">*</span>
                      </label>
                      <div className="d-flex mb-2 position-relative">
                        <div className="form-check form-check-inline">
                          <input
                            className={`form-check-input ${
                              submitted && isCommunityCat === null
                                ? "is-invalid"
                                : ""
                            }`}
                            type="radio"
                            name="isCommunityCat"
                            value={1}
                            id="communityCatYes"
                            checked={isCommunityCat == 1}
                            onChange={() => setisCommunityCat(1)}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="communityCatYes"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className={`form-check-input ${
                              submitted && isCommunityCat === null
                                ? "is-invalid"
                                : ""
                            }`}
                            type="radio"
                            name="isCommunityCat"
                            value={0}
                            id="communityCatNo"
                            checked={isCommunityCat == 0}
                            onChange={() => setisCommunityCat(0)}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="communityCatNo"
                          >
                            No
                          </label>
                        </div>
                      </div>
                      {submitted &&
                        isCommunityCat === null &&
                        animalType ===
                          "e0df8145-1d5d-ed11-9561-0022485935af" && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please choose either 'Yes' or 'No' to proceed.
                          </div>
                        )}
                    </div>
                  </>
                )}

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    10. Breed <span className="star">*</span>{" "}
                  </label>
                  <select
                    className={`form-select ${
                      submitted && !breed ? "is-invalid" : ""
                    }`}
                    aria-label="Default select example"
                    id="breed"
                    value={breed}
                    onChange={(e) => setBreed(e.target.value)}
                    required
                  >
                    <option value=""></option>
                    {breedOptionsByAnimalType[animalType]?.map(
                      (breedOption: IPetBreedModel, index: number) => (
                        <option key={index} value={breedOption.id}>
                          {breedOption.breedName}
                        </option>
                      )
                    )}
                  </select>
                  {submitted && !breed && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide a Breed.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    11. Origin <span className="star">*</span>{" "}
                  </label>
                  <select
                    className={`form-select ${
                      submitted && !origin ? "is-invalid" : ""
                    }`}
                    aria-label="Default select example"
                    id="origin"
                    value={origin}
                    onChange={handleOriginChange}
                    required
                  >
                    <option value=""></option>
                    <option value="1">Local</option>
                    <option value="2">Overseas</option>
                  </select>
                  {submitted && !origin && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please select Origin.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    12. Country of Origin{" "}
                  </label>
                  <select
                    className={`form-select`}
                    aria-label="Default select example"
                    id="countryOfOrigin"
                    value={countryOfOrigin}
                    onChange={handleCountryofOriginChange}
                  >
                    {origin !== "1" && <option value=""></option>}
                    {originCountries.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    13. Microchip No. <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !isMicrochipValid ? "is-invalid" : ""
                    }`}
                    id="microchipNo"
                    placeholder=""
                    value={microchipNo}
                    onChange={handleMicrochipChange}
                    maxLength={origin === "1" ? 15 : 100}
                    minLength={origin === "1" ? 15 : 3}
                    required
                    ref={elementRef}
                  />

                  {submitted && !microchipNo && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter Microchip No.
                    </div>
                  )}

                  {submitted && !isMicrochipValid && origin === "1" && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter a valid Microchip No. Digits 0 to 9, and it
                      should have 15 digits only.
                    </div>
                  )}

                  {submitted &&
                    microchipNo &&
                    origin === "2" &&
                    !isMicrochipValidOversease && (
                      <div className="error-message">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faCircleExclamation}
                        />
                        Please enter a valid Microchip No. Letters: A to Z,
                        Digits: 0 to 9. No special characters.
                      </div>
                    )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    14. Microchip Date <span className="star">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control ${
                      submitted && !isValidDate ? "is-invalid" : ""
                    }`}
                    id="microchipDate"
                    value={microchipDate}
                    onChange={handleDateChange}
                    max={maxdate}
                    min={minDate}
                    required
                  />
                  {submitted && !microchipDate && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter Microchip Date.
                    </div>
                  )}

                  {submitted && !isValidDate && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Microchip Date cannot be later than today's date.
                    </div>
                  )}
                  {submitted && !isMinValidDate && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter a valid year.
                    </div>
                  )}
                </div>

                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    15. Name of Pet<span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nameofPet"
                    placeholder=""
                    maxLength={255}
                    value={nameofPet}
                    onChange={(event) => setNameofPet(event.target.value)}
                  />
                  {submitted && !nameofPet && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter Name of Pet.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    16. Date of Birth <span className="star">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control ${
                      submitted && !isValidDateofBirth ? "is-invalid" : ""
                    }`}
                    id="dateofBirthPet"
                    value={dateofBirthPet}
                    onChange={handlePetbirthDateChange}
                    max={maxdate}
                    min={minDate}
                    required
                  />
                  {submitted && !dateofBirthPet && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter Date of Birth .
                    </div>
                  )}
                  {submitted && !isValidDateofBirth && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Date of Birth cannot be later than today's date and
                      microchip date.
                    </div>
                  )}
                  {submitted && !isMinValidDateofBirth && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter a valid year.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    17. Sex <span className="star">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      submitted && !sex ? "is-invalid" : ""
                    }`}
                    id="sex"
                    value={sex}
                    onChange={(e) => setSex(e.target.value)}
                    required
                  >
                    <option value=""></option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                  </select>
                  {submitted && !sex && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide a Sex.
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    18. Colour <span className="star">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      submitted && !colour ? "is-invalid" : ""
                    }`}
                    id="colour"
                    value={colour}
                    onChange={(e) => setColour(e.target.value)}
                    required
                  >
                    <option key="" value=""></option>
                    {colourOptions.map((colour) => (
                      <option key={colour.petColorID} value={colour.petColorID}>
                        {colour.colorName}
                      </option>
                    ))}
                  </select>
                  {submitted && !colour && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please select pet colour.
                    </div>
                  )}
                </div>

                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    19. Pet Address<span className="star">*</span>
                  </label>
                  <div className="mb-2">
                    <div
                      className={`form-check ${
                        !selectType ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="selectType"
                        value="1"
                        id="sameAsOwnerRadio"
                        checked={selectType === 1}
                        onChange={() => handleSelectTypeChange(1)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="sameAsOwnerRadio"
                      >
                        Same as owner
                      </label>
                    </div>
                    <div
                      className={`form-check ${
                        !selectType ? "is-invalid" : ""
                      }`}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="selectType"
                        value="2"
                        id="otherAddressRadio"
                        checked={selectType === 2}
                        onChange={() => handleSelectTypeChange(2)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="otherAddressRadio"
                      >
                        Other address
                      </label>
                    </div>
                    {submitted && !selectType && (
                      <div className="error-message">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faCircleExclamation}
                        />
                        Please select a Type.
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Postal Code
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="postalCode"
                          placeholder=""
                          maxLength={8}
                          pattern="[0-9]+"
                          value={postalCode}
                          onChange={postalCodeHandler}
                          readOnly={addressReadOnly}
                        />

                        {!postalCodeShowError && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter numbers only. eg. "123456"
                          </div>
                        )}
                      </div>
                      {petAddressErrorMessage && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          {petAddressErrorMessage}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn btn-success d-block mt-4"
                        onClick={handlePetAddressClick}
                        disabled={selectType === 1}
                      >
                        Get Address
                      </button>
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Block/House Number
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="blockNumber"
                          placeholder=""
                          maxLength={4}
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={blockNumber}
                          onChange={blockNoHandler}
                          readOnly={addressReadOnly}
                        />
                        {!blockNoShowError && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter charaters only. eg. "64FB"
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Floor Number
                      </label>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="floorNumber"
                          placeholder=""
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={floorNumber}
                          onChange={floorNoHandler}
                          maxLength={3}
                          readOnly={addressReadOnly}
                        />
                        {!floorNoShowError && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter numbers eg. "123"
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Street Name
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="streetName"
                          placeholder=""
                          maxLength={64}
                          value={streetName}
                          onChange={(event) =>
                            setStreetName(event.target.value)
                          }
                          readOnly={addressReadOnly}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Unit Number
                      </label>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="unitNumber"
                          placeholder=""
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={unitNumber}
                          onChange={unitNoHandler}
                          maxLength={4}
                          readOnly={addressReadOnly}
                        />
                        {!unitNoShowError && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter numbers eg. "1234"
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Building Name
                      </label>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="buildingName"
                          placeholder=""
                          maxLength={64}
                          value={buildingName}
                          onChange={(event) =>
                            setBuildingName(event.target.value)
                          }
                          readOnly={addressReadOnly}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    20. Sterilised <span className="star">*</span>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="sterilised"
                    value={sterilised}
                    onChange={(e) => setSterilised(e.target.value)}
                    required
                  >
                    <option value=""></option>
                    <option value={1}>Yes</option>
                    <option value={0}>No</option>
                  </select>
                </div>
                {submitted && !sterilised && (
                  <div className="error-message">
                    <FontAwesomeIcon
                      className="me-1"
                      icon={faCircleExclamation}
                    />
                    Please provide Sterilized.
                  </div>
                )}

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    21.Remarks
                  </label>
                  <textarea
                    className="form-control"
                    id="remarks"
                    placeholder=""
                    value={remarks}
                    maxLength={200}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                  <p>{remarks ? remarks.length : 0}/200</p>
                </div>

                <div className="mb-3">
                  <label htmlFor="pdfUpload" className="form-label">
                    Attachment
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="pdfUpload"
                    onChange={handleFileChange}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  />
                </div>
                <h2>Declaration</h2>
                <div className="inst-cnt mb-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={checkboxChecked}
                      onChange={handleCheckboxChange}
                      id="flexCheckDefault"
                      required
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      All the information given is correct and true to the best
                      of my knowledge.
                    </label>
                    {submitted && !checkboxChecked && (
                      <div className="error-message">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faCircleExclamation}
                        />
                        Please confirm the declaration checkbox
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={site_Key}
                  onChange={() => setIsCaptchaValid(true)}
                  onExpired={() => setIsCaptchaValid(false)}
                />
                {submitted && !isCaptchaValid && (
                  <div className="error-message">
                    <FontAwesomeIcon
                      className="me-1"
                      icon={faCircleExclamation}
                    />
                    Please complete the reCAPTCHA verification.
                  </div>
                )}
              </div>
              <div className="mb-3 d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-success d-block mt-4"
                  ref={errorRef}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondry d-block mt-4"
                  onClick={handleClear}
                >
                  Clear
                </button>
              </div>
              {isSubmiting && <Loader />}

              {errorMessage && <p className="error-message">{errorMessage}</p>}
            </div>
          </form>
        </div>
      )}
      {loginType === "CorpPass" && (
        <div>
          You are not Authorized to submit the registration. Please login as
          SingPass user to proceed.
        </div>
      )}
    </>
  );
};

export default TabPetsProfile;
